/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type CreateStepDeliveryInput = {
  IsDisabled: boolean;
  addFriendDate?: DateString | null | undefined;
  cond: string;
  endAt?: DateString | null | undefined;
  name: string;
  startAt?: DateString | null | undefined;
  steps: Array<StepDeliveryStepInput>;
};

export type StepDeliveryStepAnswerSelectionInput = {
  guid?: string | number | null | undefined;
  selection: string;
};

export type StepDeliveryStepInput = {
  answerSelections?: Array<StepDeliveryStepAnswerSelectionInput> | null | undefined;
  guid?: string | number | null | undefined;
  message: string;
  targetDayAfter: number;
  targetHour: number;
};

export type StepDeliveryCreatePageContentStepDeliveryPayloadFragment = { name: string, startAt: DateString | null, endAt: DateString | null, cond: string, addFriendDate: DateString | null, IsDisabled: boolean, steps: Array<{ stepDeliveryGuid: string, targetDayAfter: number, targetHour: number, message: string, answerSelections: Array<{ guid: string, stepDeliveryStepGuid: string, selection: string }> | null }> };

export type CreateStepDeliveryMutationVariables = Exact<{
  input: Types.CreateStepDeliveryInput;
}>;


export type CreateStepDeliveryMutation = { createStepDelivery: { StepDelivery: { name: string, startAt: DateString | null, endAt: DateString | null, cond: string, addFriendDate: DateString | null, IsDisabled: boolean, steps: Array<{ stepDeliveryGuid: string, targetDayAfter: number, targetHour: number, message: string, answerSelections: Array<{ guid: string, stepDeliveryStepGuid: string, selection: string }> | null }> } } };

export const StepDeliveryCreatePageContentStepDeliveryPayloadFragmentDoc = gql`
    fragment StepDeliveryCreatePageContentStepDeliveryPayload on StepDelivery {
  name
  startAt
  endAt
  cond
  addFriendDate
  IsDisabled
  steps {
    stepDeliveryGuid
    targetDayAfter
    targetHour
    message
    answerSelections {
      guid
      stepDeliveryStepGuid
      selection
    }
  }
}
    `;
export const CreateStepDeliveryDocument = gql`
    mutation CreateStepDelivery($input: CreateStepDeliveryInput!) {
  createStepDelivery(input: $input) {
    StepDelivery {
      ...StepDeliveryCreatePageContentStepDeliveryPayload
    }
  }
}
    ${StepDeliveryCreatePageContentStepDeliveryPayloadFragmentDoc}`;

/**
 * __useCreateStepDeliveryMutation__
 *
 * To run a mutation, you first call `useCreateStepDeliveryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateStepDeliveryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateStepDeliveryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateStepDeliveryMutation(options: VueApolloComposable.UseMutationOptions<CreateStepDeliveryMutation, CreateStepDeliveryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateStepDeliveryMutation, CreateStepDeliveryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateStepDeliveryMutation, CreateStepDeliveryMutationVariables>(CreateStepDeliveryDocument, options);
}
export type CreateStepDeliveryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateStepDeliveryMutation, CreateStepDeliveryMutationVariables>;